"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fit = void 0;
var Fit_js_1 = __importDefault(require("./Fit.js"));
exports.Fit = Fit_js_1.default;
exports.default = Fit_js_1.default;



//////////////////
// WEBPACK FOOTER
// ./~/react-fit/dist/cjs/index.js
// module id = 832
// module chunks = 0